<child-header title="Edit Product List" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <textarea style="width: 445px;height: 100px;" [(ngModel)]="data.block.stock_codes"></textarea>
    <h3 style="float:left;width:300px;color:#C20047;font-size:12px;">Seperate Stock Codes with a comma (,)</h3>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-mid" (click)="saveBlockProduct()">Save</button>
    <button mat-button class="button button-red button-mid" (click)="onNoClick()">Cancel</button>
  </div>
</div>